import React from 'react'
import ConactUsHeader from '../organisms/ContactUsHeader'
import PrivacyBody from '../organisms/PrivacyBody'
import Footer from '../organisms/Footer'
import useScrollToTop from '../../hooks/useScrollToTop'
const PrivacyPage = () => {
  useScrollToTop()
  return (
    <div className='bg-gray-100'>
      <ConactUsHeader />
      <PrivacyBody />
      <Footer />
    </div>
  )
}

export default PrivacyPage
